export function haveDifferentElements(arrayA: string[], arrayB: string[]): boolean {
  return arrayA.length !== arrayB.length || arrayA.some((x) => !arrayB.includes(x));
}
